import { buildHeadshotBlock, buildLinkResetHeader, buildSocialIconTd } from './shared';

export default (brand) => ({
  id: 2,
  name: 'Template #3',
  height: 160,
  params: ['name', 'title', 'phone', 'mobile', 'email', 'website', 'facebook', 'instagram', 'linkedin', 'twitter'],
  source: `${buildLinkResetHeader({ text: brand.text })}

<table id="body" cellpadding="0" cellspacing="0" style="width: 500px;border-collapse: collapse;" width="500" border="0">
  <tr>
    
      <td valign="top" style="width: 125px;padding-right: 10px;" width="125">
${buildHeadshotBlock({ indent: 8, size: 125, borderWidth: 0, ovalStyleDims: 'height: 125px; width: 125px;', primary: brand.primary })}
      </td>
    
    <td valign="top" style="width: 365px;" width="365">
      <table cellpadding="0" cellspacing="0" style="width: 365px;" width="365" border="0">
        <tr>
          <td valign="top" align="left" style="width: 199px;" width="199">
            <table cellpadding="0" cellspacing="0" style="width: 199px;" width="199" border="0">
              {% if name %}
                <tr>
                  <td style="color: ${brand.primary}; font-size: 18px; font-family: Helvetica, Arial, sans-serif; line-height: 20px; mso-line-height-rule: exactly; padding-bottom: 4px;">
                    <b>{{ name }}</b>
                  </td>
                </tr>
              {% endif %}
              {% if title %}
                <tr>
                  <td style="color: ${brand.text}; font-size: 14px; font-family: Helvetica, Arial, sans-serif; line-height: 20px; mso-line-height-rule: exactly; padding: 6px 0 4px 0; border-top: 2px solid ${brand.primary};">
                    <b>{{ title }}</b>
                  </td>
                </tr>
              {% endif %}
              {% if phone %}
                <tr>
                  <td valign="top" style="padding-top: 2px;">
                    <table cellpadding="0" cellspacing="0" border="0">
                      <tr>
                        <td valign="middle" style="width: 20px;padding-right: 5px;" width="20">
                          <img
                            src="{{sgcnameproto}}://{{sgcname}}/v3/icons?type=phone&background=none&color=${brand.primaryNoHash}&size=20&radius=3"
                            alt="phone"
                            style="width: 20px;height: 20px;display: block;border: 0;"
                            width="20"
                            height="20"
                          >
                        </td>
                        <td valign="middle" style="line-height: 20px;">
                          <a
                            href="tel:{{phone}}"
                            style="color: ${brand.text} !important; font-size: 12px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;"
                          >
                            {{- phone -}}
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              {% endif %}
              {% if mobile %}
                <tr>
                  <td valign="top" style="padding-top: 2px;">
                    <table cellpadding="0" cellspacing="0" border="0">
                      <tr>
                        <td valign="middle" style="width: 20px;padding-right: 5px;" width="20">
                          <img
                            src="{{sgcnameproto}}://{{sgcname}}/v3/icons?type=mobile&background=none&color=${brand.primaryNoHash}&size=20&radius=3"
                            alt="mobile"
                            style="width: 20px;height: 20px;display: block;border: 0;"
                            width="20"
                            height="20"
                          >
                        </td>
                        <td valign="middle" style="line-height: 20px;">
                          <a
                            href="tel:{{mobile}}"
                            style="color: ${brand.text} !important; font-size: 12px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;"
                          >
                            {{- mobile -}}
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              {% endif %}
              {% if email %}
                <tr>
                  <td valign="top" style="padding-top: 2px;">
                    <table cellpadding="0" cellspacing="0" border="0">
                      <tr>
                        <td valign="middle" style="width: 20px;padding-right: 5px;" width="20">
                          <img
                            src="{{sgcnameproto}}://{{sgcname}}/v3/icons?type=email&background=none&color=${brand.primaryNoHash}&size=20&radius=3"
                            alt="email"
                            style="width: 20px;height: 20px;display: block;border: 0;"
                            width="20"
                            height="20"
                          >
                        </td>
                        <td valign="middle" style="line-height: 20px;">
                          <a
                            href="mailto:{{email}}"
                            style="color: ${brand.text} !important; font-size: 12px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;"
                          >
                            {{- email -}}
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              {% endif %}
              {% if website %}
                <tr>
                  <td valign="top" style="padding-top: 2px;">
                    <table cellpadding="0" cellspacing="0" border="0">
                      <tr>
                        <td valign="middle" style="width: 20px;padding-right: 5px;" width="20">
                          <img
                            src="{{sgcnameproto}}://{{sgcname}}/v3/icons?type=website&background=none&color=${brand.primaryNoHash}&size=20&radius=3"
                            alt="web"
                            style="width: 20px;height: 20px;display: block;border: 0;"
                            width="20"
                            height="20"
                          >
                        </td>
                        <td valign="middle" style="line-height: 20px;">
                          <a
                            href="{{ website }}"
                            style="color: ${brand.text} !important; font-size: 12px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;"
                          >
                            {{- website -}}
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              {% endif %}
              <tr>
                <td style="padding-top: 8px;">
                  <table cellpadding="0" cellspacing="0" border="0">
                    <tr>
${buildSocialIconTd({ indent: 24, field: 'facebook', type: 'facebook', alt: 'facebook', background: 'none', color: brand.primaryNoHash, radius: 4 })}
${buildSocialIconTd({ indent: 24, field: 'instagram', type: 'instagram', alt: 'instagram', background: 'none', color: brand.primaryNoHash, radius: 4 })}
${buildSocialIconTd({ indent: 24, field: 'linkedin', type: 'linkedin', alt: 'linkedin', background: 'none', color: brand.primaryNoHash, radius: 4 })}
${buildSocialIconTd({ indent: 24, field: 'twitter', type: 'x', alt: 'twitter', background: 'none', color: brand.primaryNoHash, radius: 4 })}
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
          <td valign="top" align="right" style="width: 160px;padding-left: 6px;padding-top: 6px;" width="160">
            <a href="{{ website }}" target="_blank" style="text-decoration: none;display: inline-block;">
              <img
                src="${brand.logoUrl}"
                alt="Company logo"
                style="width: 160px;height: auto;display: block;border: 0;outline: none;"
                width="160"
              >
            </a>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>`
});
